import React from 'react';
export * from './plugin-access/runtime';
export * from './plugin-federated/runtime';
export { default as NotFoundComponentModule } from './NotFoundComponentModule'
const Loading = () => null;
export const fallbackDom = <Loading />;
export const fallback = <Loading />;